import { useCustomParams } from '@hooks/useCustomParams';
import {
  ConstituencyWiseResultsHeader,
  ConstituencyWiseResultsTable,
} from './components';
import { useConstituencyWiseResults } from '@hooks/useConstituencyWiseResults';

export default function ConstituencyWiseResults() {
  const { setParams, searchParams } = useCustomParams();

  const {
    constituencyWiseResults,
    isLoading,
    query,
    handleQuery,
    multipleQuery,
  } = useConstituencyWiseResults();
  return (
    <div className="pt-10">
      <ConstituencyWiseResultsHeader
        setParams={setParams}
        searchParams={searchParams}
        handleQuery={handleQuery}
      />
      <ConstituencyWiseResultsTable
        constituencyWiseResults={constituencyWiseResults}
        isLoading={isLoading}
        query={query}
        handleQuery={handleQuery}
        multipleQuery={multipleQuery}
      />
    </div>
  );
}
